import { createTheme, createVariant, globalTheme } from '@cld/component-theme';

export const tooltipTheme = createTheme(
  {
    paper: {
      background: globalTheme.palette.overlaySurface,
      color: globalTheme.palette.overlayContrast,
      border: { radius: globalTheme.radius.md },
      padding: globalTheme.spacing.xs,
      byMaxWidth: {
        sm: { maxWidth: '100px' },
        md: { maxWidth: '200px' },
        lg: { maxWidth: '300px' },
        xl: { maxWidth: '500px' },
        none: { maxWidth: 'none' },
      },
      transition: {
        duration: '200ms',
      },
    },
  },
  'tooltip'
);

export interface TooltipThemeProps {
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
}

export const maxWidthVariant = createVariant((props: TooltipThemeProps) => tooltipTheme.paper.byMaxWidth[props.maxWidth || 'none']);
